<template>
  <div>
    <div>
      <div class="bgEvent">
        <b-col
          cols="12"
          class="pre-home__bg pt-5 d-flex justify-content-left"
          :style="{ backgroundImage: `url('${publicPath}img/events/${eventId}/pre-home-bg.png?v=${this.appVersion}')` }"
        >
          <div class="bgGradient"></div>
          <h3 class="liveTitle">
            <div class="d-inline-flex"><span class="material-icons-round"> sensors </span> Interactive sessions in {{ locationCity }}</div>
          </h3>
        </b-col>
        <div>
          <!--  TABS TO SELECT ONSITE OR ONLINE LISTING -->
          <div>
            <b-tabs content-class="mt-3 pb-4" justified>
              <b-tab active>
                <template #title>
                  <span class="channeltype-row__text pr-3"><i class="las la-landmark la-6x mr-2"></i> in {{ locationCity }}</span>
                </template>

                <!-- Happening Now -->
                <div class="pb-4 mb-4">
                  <div class="text-left pb-2">
                    <span class="timeline-label__text">Happening Now</span>
                  </div>
                  <b-row no-gutters>
                    <b-col cols="12" md="4" lg="3" class="pb-2 pb-md-4 px-1 px-md-2 mb-3">
                      <SessionCard
                        :currentSession="session"
                        :isLive="session.isLive"
                        mode="Live"
                        :forceOnlineChannel="false"
                        :forceProgress="true"
                        :hideWatchButton="true"
                        :showVoteButton="true"
                        :showAskQuestionButton="true"
                        :isLiveSession="true"
                        :Ismobile="true"
                        :interactivity="true"
                      ></SessionCard>
                    </b-col>
                  </b-row>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <!-- END TABS -->
          <!-- LISTING -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SessionCard from 'src/components/Cards/SessionCard';
  //import { constants } from 'src/constants';
  import hybridEventMixin from 'src/mixins/hybridEventMixin';

  export default {
    name: 'MobileAppInteractivityDemo',
    mixins: [hybridEventMixin],
    components: {
      SessionCard,
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
      };
    },
    computed: {
      ...mapState({
        eventId: (state) => state.app.eventId,
        eventStartDate: (state) => state.app.eventStartDate,
        eventEndDate: (state) => state.app.eventEndDate,
        locationCity: (state) => state.app.locationCity 
      }),
      session() {
        return {
          recoUUID: null,
          id: 12266,
          title: 'Common conundrums in the intensive cardiac care unit: an interactive session',
          subTitle: '',
          startTime: this.eventStartDate,
          endTime: this.eventStartDate+3600000,
          channel: null,
          channelOrder: null,
          channelCode: null,
          isLive: false,
          isOnDemand: false,
          channelId: null,
          encryptedChannelId: null,
          isInInterlude: false,
          hasExternalLink: false,
          scientificSessionId: 45315,
          isIndustry: false,
          tutorialLink: null,
          channelOnSite: this.locationCity,
          channelOnSiteId: 1055,
          channelOnSiteCode: 'R1',
          channelOnSiteOrder: 1,
          isOnsite: true,
          isOnline: false,
          thumbnailURL: null,
          sessionType: 'Special Session',
          furl: null,
          channelFurl: null,
          duration: 60.0,
          progress: 18.272214058333333,
          votingUrl: 'https://escol.escardio.org/interaction/voting/00000000-0000-0000-0000-000000000000/00000000-0000-0000-0000-000000000000',
          askQuestionUrl: 'https://escol.escardio.org/interaction/ask-a-question/00000000-0000-0000-0000-000000000000/00000000-0000-0000-0000-000000000000/demo',
          channelOnSiteDisplayName: this.locationCity,
        };
      },
    },
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  @import '~@/styles/theme';

  .pre-home__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding-top: 2rem !important;
    min-height: 120px;
    background-size: 100% !important;
    z-index: 0;
  }

  .bgGradient {
    bottom: -1px;
  }

  .tabs {
    margin-top: 150px;
    position: relative;
  }

  .material-icons-round {
    font-size: 2rem;
    color: red;
    margin-right: 0.5rem;
  }

  ::v-deep .nav-tabs {
    display: none;
  }

  .button__load-more {
    color: $secondary;
    background-color: var(--congress);
    border-radius: 6px;
  }

  .comming-next__title {
    display: inline-block;
    background-color: var(--congress);
    color: $secondary;
    border-radius: 2px;
    font-size: 1.2em;
  }

  .refresh-list__alert {
    cursor: pointer;
  }

  .alert_icon {
    color: var(--congress-dark);
  }

  .channeltype-row__text {
    color: $grey-dark;
    text-transform: uppercase;
  }
  /* MOBILE APP STYLE UPDATE */
  .bgEvent {
    background-repeat: no-repeat;
    background-position: top center;
    height: 100vh;
  }

  .liveTitle {
    font-size: 1.7rem;
    z-index: 2;
  }

  .liveTitle img {
    height: 25px;
  }

  .bgEvent .card {
    border: 0;
  }

  .bgEvent .channeltype-row__text {
    color: #fff;
    text-shadow: 2px 0px 5px rgba(0, 0, 0, 0.25);
  }

  .card-body {
    padding: 0.75rem 0.5rem;
  }

  .channeltype-row__text {
    color: #000;
  }

  .channeltype-row__text i {
    position: relative;
    top: 3px;
  }
  /* tabs*/
  .nav-tabs .nav-link.active .channeltype-row__text {
    opacity: 1;
  }

  .nav-tabs .nav-link .channeltype-row__text {
    opacity: 0.6;
  }

  .tab-pane.active {
    min-width: calc(100vw - 2rem);
  }
  .timeline-label__text {
    color: #000;
    text-transform: uppercase;
    font-size: 1.1em;
  }
</style>
